// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1Ddad","actionsCol":"EnrolledClinics_actionsCol__3zhR5"};